<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="TOC">
<h2 class="contentsHead">Contents</h2>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/text/9780062016706_Dedication" title="Link target outside of Sample">Dedication</span></p>
</div>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/text/9780062016706_Epigraph#epigraphpage" title="Link target outside of Sample">Epigraph</span></p>
</div>
<p class="para"> </p>
<div class="contentsEntry" id="part_01">
<p class="contentsEntryNumber"><a href="#/text/9780062016706_Part_1#part01">Part One</a></p>
</div>
<div class="contentsEntry" id="chapter_01">
<p class="contentsEntryNumber">      <a href="#/text/9780062016706_Chapter_1#chapter01">Chapter 1</a></p>
</div>
<div class="contentsEntry" id="chapter_02">
<p class="contentsEntryNumber">      <a href="#/text/9780062016706_Chapter_2#chapter02">Chapter 2</a></p>
</div>
<div class="contentsEntry" id="chapter_03">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_3#chapter03" title="Link target outside of Sample">Chapter 3</span></p>
</div>
<div class="contentsEntry" id="chapter_04">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_4#chapter04" title="Link target outside of Sample">Chapter 4</span></p>
</div>
<p class="para"> </p>
<div class="contentsEntry" id="part_02">
<p class="contentsEntryNumber"><span href="#/text/9780062016706_Part_2#part02" title="Link target outside of Sample">Part Two</span></p>
</div>
<div class="contentsEntry" id="chapter_05">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_5#chapter05" title="Link target outside of Sample">Chapter 5</span></p>
</div>
<div class="contentsEntry" id="chapter_06">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_6#chapter06" title="Link target outside of Sample">Chapter 6</span></p>
</div>
<div class="contentsEntry" id="chapter_07">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_7#chapter07" title="Link target outside of Sample">Chapter 7</span></p>
</div>
<p class="para"> </p>
<div class="contentsEntry" id="part_03">
<p class="contentsEntryNumber"><span href="#/text/9780062016706_Part_3#part03" title="Link target outside of Sample">Part Three</span></p>
</div>
<div class="contentsEntry" id="chapter_08">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_8#chapter08" title="Link target outside of Sample">Chapter 8</span></p>
</div>
<div class="contentsEntry" id="chapter_09">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_9#chapter09" title="Link target outside of Sample">Chapter 9</span></p>
</div>
<div class="contentsEntry" id="chapter_10">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_10#chapter10" title="Link target outside of Sample">Chapter 10</span></p>
</div>
<div class="contentsEntry" id="chapter_11">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_11#chapter11" title="Link target outside of Sample">Chapter 11</span></p>
</div>
<div class="contentsEntry" id="chapter_12">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_12#chapter12" title="Link target outside of Sample">Chapter 12</span></p>
</div>
<p class="para"> </p>
<div class="contentsEntry" id="part_04">
<p class="contentsEntryNumber"><span href="#/text/9780062016706_Part_4#part04" title="Link target outside of Sample">Part Four</span></p>
</div>
<div class="contentsEntry" id="chapter_13">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_13#chapter13" title="Link target outside of Sample">Chapter 13</span></p>
</div>
<div class="contentsEntry" id="chapter_14">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_14#chapter14" title="Link target outside of Sample">Chapter 14</span></p>
</div>
<div class="contentsEntry" id="chapter_15">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_15#chapter15" title="Link target outside of Sample">Chapter 15</span></p>
</div>
<div class="contentsEntry" id="chapter_16">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_16#chapter16" title="Link target outside of Sample">Chapter 16</span></p>
</div>
<p class="para"> </p>
<div class="contentsEntry" id="part_05">
<p class="contentsEntryNumber"><span href="#/text/9780062016706_Part_5#part05" title="Link target outside of Sample">Part Five</span></p>
</div>
<div class="contentsEntry" id="chapter_17">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_17#chapter17" title="Link target outside of Sample">Chapter 17</span></p>
</div>
<div class="contentsEntry" id="chapter_18">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_18#chapter18" title="Link target outside of Sample">Chapter 18</span></p>
</div>
<div class="contentsEntry" id="chapter_19">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_19#chapter19" title="Link target outside of Sample">Chapter 19</span></p>
</div>
<div class="contentsEntry" id="chapter_20">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_20#chapter20" title="Link target outside of Sample">Chapter 20</span></p>
</div>
<p class="para"> </p>
<div class="contentsEntry" id="part_06">
<p class="contentsEntryNumber"><span href="#/text/9780062016706_Part_6#part06" title="Link target outside of Sample">Part Six</span></p>
</div>
<div class="contentsEntry" id="chapter_21">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_21#chapter21" title="Link target outside of Sample">Chapter 21</span></p>
</div>
<div class="contentsEntry" id="chapter_22">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_22#chapter22" title="Link target outside of Sample">Chapter 22</span></p>
</div>
<div class="contentsEntry" id="chapter_23">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_23#chapter23" title="Link target outside of Sample">Chapter 23</span></p>
</div>
<div class="contentsEntry" id="chapter_24">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_24#chapter24" title="Link target outside of Sample">Chapter 24</span></p>
</div>
<p class="para"> </p>
<div class="contentsEntry" id="part_07">
<p class="contentsEntryNumber"><span href="#/text/9780062016706_Part_7#part07" title="Link target outside of Sample">Part Seven</span></p>
</div>
<div class="contentsEntry" id="chapter_25">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_25#chapter25" title="Link target outside of Sample">Chapter 25</span></p>
</div>
<div class="contentsEntry" id="chapter_26">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_26#chapter26" title="Link target outside of Sample">Chapter 26</span></p>
</div>
<div class="contentsEntry" id="chapter_27">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_27#chapter27" title="Link target outside of Sample">Chapter 27</span></p>
</div>
<div class="contentsEntry" id="chapter_28">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_28#chapter28" title="Link target outside of Sample">Chapter 28</span></p>
</div>
<p class="para"> </p>
<div class="contentsEntry" id="part_08">
<p class="contentsEntryNumber"><span href="#/text/9780062016706_Part_8#part08" title="Link target outside of Sample">Part Eight</span></p>
</div>
<div class="contentsEntry" id="chapter_29">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_29#chapter29" title="Link target outside of Sample">Chapter 29</span></p>
</div>
<div class="contentsEntry" id="chapter_30">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_30#chapter30" title="Link target outside of Sample">Chapter 30</span></p>
</div>
<p class="para"> </p>
<div class="contentsEntry" id="part_09">
<p class="contentsEntryNumber"><span href="#/text/9780062016706_Part_9#part09" title="Link target outside of Sample">Part Nine</span></p>
</div>
<div class="contentsEntry" id="chapter_31">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_31#chapter31" title="Link target outside of Sample">Chapter 31</span></p>
</div>
<div class="contentsEntry" id="chapter_32">
<p class="contentsEntryNumber">      <span href="#/text/9780062016706_Chapter_32#chapter32" title="Link target outside of Sample">Chapter 32</span></p>
</div>
<p class="para"> </p>
<div class="contentsEntry1" id="backmatterpage_02">
<p class="contentsEntryName"><span href="#/text/9780062016706_Backmatter#backmatterpage02" title="Link target outside of Sample">Plus:</span> Insights, Interviews, And More</p>
</div>
<div class="contentsEntry1" id="acknowledgment_page">
<p class="contentsEntryName"><span href="#/text/9780062016706_Acknowledgment#acknowledgmentpage" title="Link target outside of Sample">Acknowledgments</span></p>
</div>
<div class="contentsEntry1" id="adcard_page">
<p class="contentsEntryName"><span href="#/text/9780062016706_AlsoBy#adcardpage" title="Link target outside of Sample">Other Books by Tim Farrington</span></p>
</div>
<div class="contentsEntry1" id="copyright_page">
<p class="contentsEntryName"><span href="#/text/9780062016706_Copyright#copyrightpage" title="Link target outside of Sample">Copyright</span></p>
</div>
<div class="contentsEntry1" id="aboutpublisher_page">
<p class="contentsEntryName"><span href="#/text/About_the_Publisher#aboutpublisherpage" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062016706_Contents.vue?28816cb6